export const MARKET_API = import.meta.env?.DEV ? 'http://localhost:5173/finance/bvb/api' : 'https://widgets.adh.reperio.news/finance/bvb/api';
export const INDEX_NAMES = {
	BET: 'Companiile de referință ale bursei',
	'BET-TR': 'Evoluția BET, cu dividende reinvestite',
	'BET-NG': 'Companii din energie și utilități',
	BETAeRO: 'Companii de pe piața AeRO',
};
export const number = (value, digits = 2) => new Intl.NumberFormat('ro-RO', { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(value);
export const price = (value) => new Intl.NumberFormat('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 4 }).format(value);
export const turnover = (value) => value >= 1e6 ? `${number(value / 1e6)} mil.` : value >= 1e3 ? `${number(value / 1e3, 1)} mii` : number(value, 0);
export const change = (value) => `${value > 0 ? '+' : ''}${number(value)}%`;
export const direction = (value) => value > 0 ? '▲' : value < 0 ? '▼' : '=';
export const quoteLabel = (value) => {
	const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}:\d{2}):\d{2}\+0[23]:00$/.exec(value || '');
	return match ? `${match[3]}.${match[2]}.${match[1]} · ${match[4]}` : '';
};
export function usableMarket(market, now = Date.now()) {
	if (!market || !quoteLabel(market.quotedAt)) return false;
	const collected = Date.parse(market.updated), quoted = Date.parse(market.quotedAt);
	return Number.isFinite(collected) && Number.isFinite(quoted)
		&& collected <= now + 60000 && quoted <= now + 5 * 60000
		&& now - collected <= 7 * 86400000 && now - quoted <= 7 * 86400000;
}
let pending;
let last = null;
let expires = 0;
export async function fetchMarket() {
	if (last && Date.now() < expires && usableMarket(last)) return last;
	if (pending) return pending;
	pending = (async () => {
		try {
			const signal = typeof AbortSignal !== 'undefined' && AbortSignal.timeout ? AbortSignal.timeout(20000) : undefined;
			const response = await fetch(MARKET_API, { signal });
			if (!response.ok) return null;
			const body = await response.json();
			const market = body?.market;
			if (!body.ok || !quoteLabel(market?.quotedAt) || !usableMarket(market) || !Array.isArray(market.indices) || !Array.isArray(market.shares)) return null;
			if (market.indices.length !== 4 || new Set(market.indices.map(item => item.symbol)).size !== 4 || !market.indices.every(item => INDEX_NAMES[item.symbol] && Number.isFinite(item.value) && item.value > 0 && Number.isFinite(item.change))) return null;
			if (!market.shares.every(item => /^[A-Z][A-Z0-9]{0,11}$/.test(item.symbol) && typeof item.name === 'string' && Number.isFinite(item.price) && item.price > 0 && Number.isFinite(item.change) && Number.isFinite(item.turnover) && item.turnover > 0)) return null;
			last = { ...market, stale: market.stale === true || Date.now() - Date.parse(market.updated) > 20 * 60000, shares: market.shares.slice(0, 5) };
			expires = Date.now() + 60000;
			return last;
		} catch { return null; }
	})().finally(() => { pending = null; });
	return pending;
}

// Fixed, explicitly labelled editor and verification data. Never a public fallback.
export function sampleMarket() {
	return {
		quotedAt: '2026-10-27T16:30:00+02:00', updated: '2026-10-27T14:31:00Z', stale: false,
		indices: [
			{ symbol: 'BET', value: 34355.94, change: -0.16 },
			{ symbol: 'BET-TR', value: 83002.48, change: -0.16 },
			{ symbol: 'BET-NG', value: 2751.79, change: 0.51 },
			{ symbol: 'BETAeRO', value: 1020.81, change: 0 },
		],
		shares: [
			{ symbol: 'SNG', name: 'Romgaz', price: 18.16, change: -0.77, turnover: 7892305.56, time: '16:25:38' },
			{ symbol: 'TLV', name: 'Banca Transilvania', price: 36.2, change: -0.55, turnover: 6170620.54, time: '16:26:23' },
			{ symbol: 'RRC', name: 'Rompetrol Rafinare', price: 1.16, change: 14.85, turnover: 3380539.48, time: '16:26:35' },
			{ symbol: 'SNN', name: 'Nuclearelectrica', price: 57.4, change: -1.54, turnover: 3364249.60, time: '16:28:46' },
			{ symbol: 'H2O', name: 'Hidroelectrica', price: 182.8, change: 1.67, turnover: 3315411, time: '16:29:27' },
		],
	};
}
